import React from 'react';
import PropTypes from 'prop-types';

import pluralize from 'pluralize';
import { Alert } from 'react-bootstrap-5';

export default function DealWarning({ listing }) {
  if (!listing || !listing.dealCount) {
    return null;
  }

  let listingChildLabel;
  if (listing.type === 'LeaseSpaceListing') {
    listingChildLabel = 'lease space';
  } else if (listing.type === 'LotListing') {
    listingChildLabel = 'lot';
  } else if (listing.type === 'CondoListing') {
    listingChildLabel = 'condo';
  } else {
    listingChildLabel = 'listing';
  }

  return (
    <Alert variant="warning">
      This {listingChildLabel} already has <b>{pluralize('deal', listing.dealCount, true)}</b> connected to it.
    </Alert>
  );
}

DealWarning.propTypes = {
  listing: PropTypes.shape({
    dealCount: PropTypes.number,
    type: PropTypes.string,
  }),
};
